import { Router, useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { LocaleStore } from 'schema/locale';
import { useLocale } from 'shared/hooks/useLocale';
import { usePreviousRoute } from 'shared/hooks/usePreviousRoute';
import { GAEventName } from './ga-event-name.enum';
import { sendAnalytics } from './send-analytics';

export const useAnalyticsPageView = () => {
  const locale = useLocale();
  const store = LocaleStore[locale];
  const router = useRouter();
  const previousRoute = usePreviousRoute();
  const [initialViewSent, setInitialViewSent] = useState(false);

  // Handle initial page load
  useEffect(() => {
    if (typeof window === 'undefined' || !router.isReady || initialViewSent) {
      return;
    }

    try {
      sendAnalytics({
        event: GAEventName.HISTORY_CHANGE,
        store,
        page: router.asPath,
        is_initial_pageview: true
      });
      setInitialViewSent(true);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to send initial pageview:', error);
    }
  }, [router.isReady, router.asPath, store, initialViewSent]);

  // Handle route changes
  useEffect(() => {
    const handleRouteChange = async (url: string) => {
      try {
        await sendAnalytics({
          event: GAEventName.HISTORY_CHANGE,
          store,
          page: url,
          previous_route: previousRoute || undefined
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to send route change:', error);
      }
    };

    Router.events.on('routeChangeComplete', handleRouteChange);
    return () => Router.events.off('routeChangeComplete', handleRouteChange);
  }, [store, previousRoute]);

  return null;
};
